import { PaymentMethodConfiguration } from '../model';
import { PaymentMethodConfigurationEnricher } from './paymentMethodConfigurationEnricher';

interface PaymentMethodConfigurationProvider {
  get(paymentMethodId: string): PaymentMethodConfiguration;
  getDefault(): PaymentMethodConfiguration;
}

const DEFAULT_PAYMENT_METHOD_CONFIGURATION: PaymentMethodConfiguration = {
  copyableText: {
    type: 'standard',
  },
  informationBlock: {
    type: 'standard',
  },
  qrCode: {
    type: 'square',
  },
  paymentResult: {
    paymentMethodLogo: 'displayed',
  }
};

export const paymentMethodConfigurationProvider: PaymentMethodConfigurationProvider =
  {
    get(paymentMethodId: string): PaymentMethodConfiguration {
      const configuration = DEFAULT_PAYMENT_METHOD_CONFIGURATION;

      PaymentMethodConfigurationEnricher.enrich(configuration, paymentMethodId);

      return configuration;
    },
    getDefault() {
      return DEFAULT_PAYMENT_METHOD_CONFIGURATION;
    },
  };
